import styled from "styled-components";
import { theme } from "@themes";

export const PositionLogoContainer = styled.div`
  margin: 10px;
  width: 90% !important;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  border-radius: 3px;
  display: grid;
  grid-auto-columns: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;
`;

export const SizeLogoContainer = styled.div`
  margin: 10px;
  width: 90% !important;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  border-radius: 3px;
  display: grid;
  grid-auto-columns: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;
`;

export const Body = styled.div`
  justify-content: flex-start;
  width: 80%;
`;

export const Title = styled.title`
  width: 28px;
  height: 19px;
  left: 447px;
  top: 262px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.01em;
`;

export const RadioSize = styled.div`
  margin: 0.4rem;
  text-align: start;
  #labelRadioSurvey {
    margin: 0.3rem;
    text-transform: capitalize;
  }
  input {
    transform: scale(1.3);
    margin-right: 0.4em;
  }
`;

export const ContainerUploadImage = styled.div`
  padding: 10px 34px 0px 10px;
`;
